export const LOGIN_PATH = "/login";
export const REGISTER_PATH = "/register";
export const ACCOUNT_PATH = "/account";
export const ACCOUNT_VERIFY_PATH = "/account/verify";
export const ACCOUNT_ORDER_PREFIX = "/account/orders/";
